import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { FAILED_LOGIN_TYPE_LABELS } from '../../constants/configuredReportFilterOptions'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDateTime } from '../../utils/configuredReportFormatters'

export const failedLoginsColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'name',
    label: 'Name',
    sortKey: 'applicant_first_name',
    render: (row) => display(row.name),
  },
  {
    id: 'email',
    label: 'Email',
    sortKey: 'email',
    render: (row) => display(row.email),
  },
  {
    id: 'type',
    label: 'Type',
    sortKey: 'type',
    render: (row) =>
      FAILED_LOGIN_TYPE_LABELS[String(row.type ?? '')] ?? display(row.type),
  },
  {
    id: 'created_at',
    label: 'Date',
    sortKey: 'created_at',
    render: (row) => formatDateTime(row.created_at),
  },
  {
    id: 'ip_address',
    label: 'IP Address',
    sortKey: 'ip_address',
    render: (row) => display(row.ip_address),
  },
]
